export default __webpack_public_path__ + "static/media/punjab.a3d15f66.png";